import { render } from "./CustomDataTagsModal.vue?vue&type=template&id=5837d0d4&scoped=true"
import script from "./CustomDataTagsModal.vue?vue&type=script&lang=js"
export * from "./CustomDataTagsModal.vue?vue&type=script&lang=js"

import "./CustomDataTagsModal.vue?vue&type=style&index=0&id=5837d0d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5837d0d4"]])

export default __exports__